const cartoucheMultiCottage = function (datas) {
  return `
  <div class="cartMulti themBorderColor">
    <div class="cartMulti-icon">
      <i class="icon icon-multiCottage"></i>
      <span>x${datas.hasToDisplayPushSingleCottage ? '&nbsp;1' : '&nbsp;2'}</span>
    </div>
    <div class="cartMulti-texts">
      <div class="cartMulti-title${datas.smallTitle ? ' cartMulti-title--small' : ''}">${datas.title}</div>
      <div class="cartMulti-text">${datas.text1}${typeof datas.text2 !== 'undefined' ? '</br>' + datas.text2 : ''}</div>
    </div>
    ${datas.hasToDisplayPushMultiCottage || datas.hasToDisplayPushSingleCottage ?
    `<div class="cartMulti-button">
      <span class="button button--transparentBlack js-action" data-pushNumberCottage="${datas.pushNumber}">${datas.buttonLabel}</span>
    </div>` : '' }
  </div>`;
};

export { cartoucheMultiCottage };